import React from 'react';
import SideNavigation, { SideNavigationProps } from '@amzn/awsui-components-react/polaris/side-navigation';
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { projectTitle } from '../constants';
const navHeader = { text: projectTitle, href: '/' };



export const navItems: SideNavigationProps['items'] = [
  {
    type: 'section',
    text: 'Navigation',
    items: [
      { type: 'link', text: 'Home', href: '/' },
      { type: 'link', text: 'Upload File(s)', href: '/uploadfiles' },
      { type: 'link', text: 'Stats', href: '/stats' },
      { type: 'link', text: 'About', href: '/about' },
    ],
  }
];

interface NavigationProps {
  activeHref?: string;
  header?: SideNavigationProps['header'];
  items?: SideNavigationProps['items'];
  onFollowHandler?: SideNavigationProps['onFollow'];
  onFeedbackClick?: () => void; // Keeping the prop for backward compatibility
}

export function Navigation({
  activeHref,
  header = navHeader,
  items = navItems,
  onFeedbackClick,
  // onFollowHandler = defaultOnFollowHandler,
}: NavigationProps) {
  let location = useLocation();
  const navigate = useNavigate()
  const [activeHref2, setActiveHref] = React.useState('/');

  return <SideNavigation items={items} header={header} activeHref={location.pathname} onFollow={(event) => {
    // Keeping the handler logic for backward compatibility, but it won't be triggered
    // since the feedback item has been removed
    if (event.detail.id === 'side-nav-feedback') {
      event.preventDefault();
      if (onFeedbackClick) {
        onFeedbackClick();
      }
    } else if (!event.detail.external) {
      event.preventDefault();
      setActiveHref(event.detail.href)
      navigate(event.detail.href)
    }
  }} />;
}
